import service from '@/utils/request'

export const getAppVersionList = () => {
  return service({
    url: '/uAppVersion/getAppVersionList',
    method: 'post'
  })
}

export const updateAppVersion = (data) => {
  return service({
    url: '/uAppVersion/updateAppVersion',
    method: 'post',
    data
  })
}

export const addBanner = (data) => {
  return service({
    url: '/uMarket/banner/addBanner',
    method: 'post',
    data
  })
}

export const getBannerList = (data) => {
  return service({
    url: '/uMarket/banner/getBannerList',
    method: 'post',
    data
  })
}

export const delBanner = (data) => {
  return service({
    url: '/uMarket/banner/delBanner',
    method: 'post',
    data
  })
}

export const updateBanner = (data) => {
  return service({
    url: '/uMarket/banner/updateBanner',
    method: 'post',
    data
  })
}

export const getBaseConfig = (data) => {
  return service({
    url: '/uMarket/config/getBaseConfig',
    method: 'post',
    data
  })
}

export const setBaseConfig = (data) => {
  return service({
    url: '/uMarket/config/setBaseConfig',
    method: 'post',
    data
  })
}

export const getMarqueeMsgList = (data) => {
  return service({
    url: '/uMarket/config/getMarqueeMsgList',
    method: 'post',
    data
  })
}

export const addMarqueeMsg = (data) => {
  return service({
    url: '/uMarket/config/addMarqueeMsg',
    method: 'post',
    data
  })
}

export const updateMarqueeMsg = (data) => {
  return service({
    url: '/uMarket/config/updateMarqueeMsg',
    method: 'post',
    data
  })
}

export const delMarqueeMsg = (data) => {
  return service({
    url: '/uMarket/config/delMarqueeMsg',
    method: 'post',
    data
  })
}

export const addActivityShow = (data) => {
  return service({
    url: '/uMarket/config/addActivityShow',
    method: 'post',
    data
  })
}

export const delActivityShow = (data) => {
  return service({
    url: '/uMarket/config/delActivityShow',
    method: 'post',
    data
  })
}

export const getActivityShowList = (data) => {
  return service({
    url: '/uMarket/config/getActivityShowList',
    method: 'post',
    data
  })
}

export const updateActivityShow = (data) => {
  return service({
    url: '/uMarket/config/updateActivityShow',
    method: 'post',
    data
  })
}

export const addMedia = (data) => {
  return service({
    url: '/uMarket/config/addMedia',
    method: 'post',
    data
  })
}

export const getMediaList = (data) => {
  return service({
    url: '/uMarket/config/getMediaList',
    method: 'post',
    data
  })
}

export const updateMedia = (data) => {
  return service({
    url: '/uMarket/config/updateMedia',
    method: 'post',
    data
  })
}

export const delMedia = (data) => {
  return service({
    url: '/uMarket/config/delMedia',
    method: 'post',
    data
  })
}

export const getSiteShareConfig = (data) => {
  return service({
    url: '/uMarket/config/getSiteShareConfig',
    method: 'post',
    data
  })
}

export const setSiteShareConfig = (data) => {
  return service({
    url: '/uMarket/config/setSiteShareConfig',
    method: 'post',
    data
  })
}

export const addCustomerSvc = (data) => {
  return service({
    url: '/uMarket/config/addCustomerSvc',
    method: 'post',
    data
  })
}

export const delCustomerSvc = (data) => {
  return service({
    url: '/uMarket/config/delCustomerSvc',
    method: 'post',
    data
  })
}

export const getCustomerSvcList = (data) => {
  return service({
    url: '/uMarket/config/getCustomerSvcList',
    method: 'post',
    data
  })
}

export const updateCustomerSvc = (data) => {
  return service({
    url: '/uMarket/config/updateCustomerSvc',
    method: 'post',
    data
  })
}

export const addRechargeTemplate = (data) => {
  return service({
    url: '/uMarket/config/addRechargeTemplate',
    method: 'post',
    data
  })
}

export const delRechargeTemplate = (data) => {
  return service({
    url: '/uMarket/config/delRechargeTemplate',
    method: 'post',
    data
  })
}

export const getRechargeTemplateList = (data) => {
  return service({
    url: '/uMarket/config/getRechargeTemplateList',
    method: 'post',
    data
  })
}

export const updateRechargeTemplate = (data) => {
  return service({
    url: '/uMarket/config/updateRechargeTemplate',
    method: 'post',
    data
  })
}

export const getActivityList = (data) => {
  return service({
    url: '/uActivity/getActivityList',
    method: 'post',
    data
  })
}

export const getActivityGroupList = (data) => {
  return service({
    url: '/uActivity/getActivityGroupList',
    method: 'post',
    data
  })
}

export const updateActivity = (data) => {
  return service({
    url: '/uActivity/updateActivity',
    method: 'post',
    data
  })
}

/**道具列表 */
export const getPropList = (data) => {
  return service({
    url: '/uMarket/config/getPropList',
    method: 'post',
    data
  })
}

/**更新道具 */
export const updateProp = (data) => {
  return service({
    url: '/uMarket/config/updateProp',
    method: 'post',
    data
  })
}

/**删除道具 */
export const delProp = (data) => {
  return service({
    url: '/uMarket/config/delProp',
    method: 'post',
    data
  })
}

/**添加道具 */
export const addProp = (data) => {
  return service({
    url: '/uMarket/config/addProp',
    method: 'post',
    data
  })
}

/**添加道具 */
export const handoutPinataProp = (data) => {
  return service({
    url: '/uActivity/handoutPinataProp',
    method: 'post',
    data
  })
}


/**获取排名奖励配置列表 */
export const getBettingRankingConfigList = (data) => {
  return service({
    url: '/rank/getBettingRankingConfigList',
    method: 'post',
    data
  })
}


/**更新排名奖励配置 */
export const updateBettingRankingConfig = (data) => {
  return service({
    url: '/rank/updateBettingRankingConfig',
    method: 'post',
    data
  })
}


/**新增用户排名配置 */
export const createBettingRankingConfig = (data) => {
  return service({
    url: '/rank/createBettingRankingConfig',
    method: 'post',
    data
  })
}


/**获取领取记录 */
export const getBettingRankingRewardLogList = (data) => {
  return service({
    url: '/rank/getBettingRankingRewardLogList',
    method: 'post',
    data
  })
}

/**修改活动排序 */
export const updateActivityWeight = (data) => {
  return service({
    url: '/uActivity/updateActivityWeight',
    method: 'post',
    data
  })
}



/**获取S3配置 */
export const getS3Config = () => {
  return service({
    url: '/uSite/getS3Config',
    method: 'post'
  })
}

/**获取平台当前时间 */
export const getPlatformTime = () => {
  return service({
    url: '/uSite/getPlatformTime',
    method: 'post'
  })
}


// 获取充值设置
export const getRechargeSetting = (data) => {
  return service({
    url: '/uPay/getRechargeSetting',
    method: 'post',
    data
  })
}

// 设置充值配置
export const setRechargeSetting = (data) => {
  return service({
    url: '/uPay/setRechargeSetting',
    method: 'post',
    data
  })
}


// 获取提现设置
export const getWithdrawSetting = (data) => {
  return service({
    url: '/uPay/getWithdrawSetting',
    method: 'post',
    data
  })
}

// 设置提现设置
export const setWithdrawSetting = (data) => {
  return service({
    url: '/uPay/setWithdrawSetting',
    method: 'post',
    data
  })
}

// 获取用户模板
export const getUserTemplateList = (data) => {
  return service({
    url: '/uUsers/getUserTemplateList',
    method: 'post',
    data
  })
}

// 新增用户模板
export const addUserTemplate = (data) => {
  return service({
    url: '/uUsers/addUserTemplate',
    method: 'post',
    data
  })
}


// 更新用户模板
export const updateUserTemplate = (data) => {
  return service({
    url: '/uUsers/updateUserTemplate',
    method: 'post',
    data
  })
}

// 新增：删除用户模板
export const deleteUserTemplate = (data) => {
  return service({
    url: '/uUsers/deleteUserTemplate',
    method: 'post',
    data
  })
}

export const avatarList = (data) => {
  return service({
    url: '/avatar/list',
    method: 'post',
    data
  })
}

export const avatarCreate = (data) => {
  return service({
    url: '/avatar/create',
    method: 'post',
    data
  })
}

export const avatarUpdate = (data) => {
  return service({
    url: '/avatar/update',
    method: 'post',
    data
  })
}

export const avatarDelete = (data) => {

  return service({
    url: '/avatar/delete',
    method: 'post',
    data
  })
}

export const avatarFrameList = (data) => {
  return service({
    url: '/avatar/frame/list',
    method: 'post',
    data
  })
}

export const avatarFrameUpdate = (data) => {
  return service({
    url: '/avatar/frame/update',
    method: 'post',
    data
  })
}


export const avatarFrameCreate = (data) => {
  return service({
    url: '/avatar/frame/create',
    method: 'post',
    data
  })
}

export const avatarFrameDelete = (data) => {
  return service({
    url: '/avatar/frame/delete',
    method: 'post',
    data
  })
}


// 授予用户头像框
export const avatarBackpackGrant = (data) => {
  return service({
    url: '/avatar/backpack/grant',
    method: 'post',
    data
  })
}


// 收回用户头像框
export const avatarBackpackRevoke = (data) => {
  return service({
    url: '/avatar/backpack/revoke',
    method: 'post',
    data
  })
}



// 获取用户头像框列表
export const avatarBackpackList = (data) => {
  return service({
    url: '/avatar/backpack/list',
    method: 'post',
    data
  })
}

// 获取注册配置
export const getUserRegisterTemplateList = (data) => {
  return service({
    url: '/uUsers/getUserRegisterTemplateList',
    method: 'post',
    data
  })
}



export const setUserRegisterTemplateList = (data) => {
  return service({
    url: '/uUsers/updateUserRegisterTemplate',
    method: 'post',
    data
  })
}


// 获取语言数据
export const getLanguageConfigList = (params) => {
  return service({
    url: '/commonRoute/getLanguageConfigList',
    method: 'get',
    params
  })
}


// 获取移动端首页接口
export const getMobileHomeInterface = (data) => {
  return service({
    url: '/uMarket/config/getMobileConfig',
    method: 'post',
    data
  })
}

// 设置移动端首页接口
export const setMobileHomeInterface = (data) => {
  return service({
    url: '/uMarket/config/setMobileConfig',
    method: 'post',
    data
  })
}

// 获取用户层级列表
export const getUserLayerList = (data) => {
  return service({
    url: '/userLayerConfig/list',
    method: 'post',
    data
  })
}



export const getAgentBannerSetting = (data) => {
  return service({
    url: '/uPay/getAgentBannerSetting',
    method: 'post',
    data
  })
}

// 获取用户层级列表
export const setAgentBannerSetting = (data) => {
  return service({
    url: '/uPay/setAgentBannerSetting',
    method: 'post',
    data
  })
}

export const getAgentActivitySetting = (data) => {
  return service({
    url: '/uPay/getAgentActivitySetting',
    method: 'post',
    data
  })
}

// 获取用户层级列表
export const setAgentActivitySetting = (data) => {
  return service({
    url: '/uPay/setAgentActivitySetting',
    method: 'post',
    data
  })
}


export const getLinkUrlSetting = (data) => {
  return service({
    url: '/uPay/getLinkUrlSetting',
    method: 'post',
    data
  })
}

// 获取用户层级列表
export const setLinkUrlSetting = (data) => {
  return service({
    url: '/uPay/setLinkUrlSetting',
    method: 'post',
    data
  })
}

// 获取系统配置列表
export const getSysConfigList = (data) => {
  return service({
    url: '/uMarket/sys/getSysConfigList',
    method: 'post',
    data
  })
}

// 更新系统配置
export const updateSysConfig = (data) => {
  return service({
    url: '/uMarket/sys/updateSysConfig',
    method: 'post',
    data
  })
}

// ==================== 活动显示配置相关 API ====================

// 获取活动显示配置列表
export const getActivityDisplayConfig = (data) => {
  return service({
    url: '/uActivity/getActivityDisplayConfig',
    method: 'post',
    data
  })
}

// 保存活动显示配置
export const saveActivityDisplayConfig = (data) => {
  return service({
    url: '/uActivity/saveActivityDisplayConfig',
    method: 'post',
    data
  })
}

// 删除活动显示配置
export const deleteActivityDisplayConfig = (data) => {
  return service({
    url: '/uActivity/deleteActivityDisplayConfig',
    method: 'post',
    data
  })
}

// 获取活动排序预览
export const getActivitySortPreview = (data) => {
  return service({
    url: '/uActivity/getActivitySortPreview',
    method: 'post',
    data
  })
}
// 为活动组添加活动
export const addActivityForGroup = (data) => {
  return service({
    url: '/uActivity/addActivityForGroup',
    method: 'post',
    data
  })
}

// 删除活动组中的活动
export const delActivityForGroup = (data) => {
  return service({
    url: '/uActivity/delActivityForGroup',
    method: 'post',
    data
  })
}
